import Head from "next/head";
import DefaultLayout from "@/components/DefaultLayout";
import SliderBarLeft from "@/components/SliderBarLeft";
import SliderBarRight from "@/components/SliderBarRight";
import ShopInfo from "@/components/ShopInfo";
import styles from "@/styles/zippay.module.scss";
import { usePathname } from "next/navigation";
import ArticleTemplate from "@/components/article/ArticleTemplate";

export default function Zippay() {
  const pathname = usePathname();
  const articleName = pathname.split("/").pop() || "";

  return (
    <>
      <Head>
        <title>
          Online Shopping Australia - Beauty & Health, Computers, Toys, - Deals
          & Discounts | CrazySales
        </title>
        <meta
          name="keywords"
          content="Online Shopping Australia, online shopping sites, Home Shopping, Shopping Deals, Best Deals, Home Garden, Pet Supplies, Sports Fitness, Bedding Bath, Buy Online, Discount Shopping, Toys Hobbies, Beauty Health, Crazy Sales, Computers, IT, Christmas, Electronics, Automotive, Tools, Appliances, Baby, CrazySales"
        ></meta>
        <meta
          name="description"
          content="CrazySales.com.au - Australia's #1 online shopping website! Cheap bargains &amp; discounts with the top online shopping Australia store! From furniture, to toys &amp; hobbies, to appliances &amp; pet supplies -- we've got it all, with free shipping on selected items!"
        ></meta>
      </Head>

      <DefaultLayout notStickyNavbar={true}>
        <div className={`${styles["page-zippay"]} slider-wapper`}>
          <SliderBarLeft></SliderBarLeft>
          <SliderBarRight></SliderBarRight>

          <div className={styles["shop-info-box"]}>
            <ShopInfo hiddenContactus={true}></ShopInfo>
          </div>

          <ArticleTemplate articleName={articleName} />
        </div>
      </DefaultLayout>
    </>
  );
}
